module.exports = __webpack_public_path__ + "img/humanar_logo.468f130a.svg";